<template>
    <div class="description">
        <div class="title">
            {{ title }}
            <Tip v-if="showTip" class="tip">{{ tip }}</Tip>
        </div>
        <div class="content">{{ finalContent }}
            <i
                v-if="desensitize"
                :class="`icon icon-co_preview_${previewDesensitizeString?'on':'off'}`"
                @click="previewDesensitizeString = !previewDesensitizeString"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { desensitizeString } from '@/filter';
import Vue from 'vue';
import Tip from '@/basic/Tip.vue';

export default Vue.extend({
    components: { Tip },
    props: {
        title: String,
        content: String,
        desensitize: Boolean,
        tip: String,
        showTip: {
            type: Boolean,
            default: false
        }
    },
    name: 'ReoDescription',
    data() {

        return {
            previewDesensitizeString: false
        };

    },
    computed: {
        finalContent(): string {

            if ( !this.desensitize || this.previewDesensitizeString ) {

                return this.content;

            } else {

                return desensitizeString( this.content );

            }

        }

    }
});
</script>

<style lang="less" scoped>
.description{
    .title{
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        .tip{
            margin-left: 5px;
        }
    }
    .content{
        font-size: 16px;
        font-weight: 500;
        color: @font_secondary;
        display: flex;
        gap: 8px;
        align-items: center;
        .icon{
            font-size: 20px;
            cursor: pointer;
        }
    }
}
</style>
